import React, { useState, useEffect } from 'react';
import './Simulation.css';

const PRICES = {
    // Coûts uniques (Installation)
    installation: { PC: 90, NAS: 180, PHYSIQUE: 270, VIRTUALISE: 270 },
    vms_install: { 1: 90, 2: 180, 3: 270, 4: 360, 5: 450, plus: "DEVIS" },

    // Coûts mensuels (Abonnement)
    stockage: {
        100: 14.9, 500: 29.9, 1000: 49.9, 2000: 79.9, 4000: 129.9, auDela: "DEVIS"
    },
    test_mensuel: { PC: 4.9, NAS: 9.9, SERVEUR: 49.9 }
};

export default function Simulation() {
    const [config, setConfig] = useState({
        type: 'PC',
        nbVM: 1,
        volume: 100,
        connexion: 'FTTH',
        upload: 50,
        testSauvegarde: false
    });

    const [totalMensuel, setTotalMensuel] = useState(0);
    const [fraisInstallation, setFraisInstallation] = useState(0);
    const [isDevis, setIsDevis] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mensuel = 0;
        let install = 0;
        let devisDetecte = false;
        let errorMsg = null;

        // --- Validation Connexion ---
        if (config.connexion === 'ADSL') {
            errorMsg = "Sauvegarde impossible sur ligne ADSL.";
        } else if (config.connexion === 'FTTO' && config.upload < 20) {
            errorMsg = "Débit d'upload trop faible (< 20 Mbit/s).";
        }

        // --- Calcul Frais Installation (Unique) ---
        if (config.type === 'VIRTUALISE') {
            if (config.nbVM === 'plus') devisDetecte = true;
            else install = PRICES.vms_install[config.nbVM];
        } else {
            install = PRICES.installation[config.type];
        }

        // --- Calcul Mensuel (Abonnement) ---
        if (config.volume === 'auDela') devisDetecte = true;
        else mensuel += PRICES.stockage[config.volume];

        if (config.testSauvegarde) {
            if (config.type === 'PC') mensuel += PRICES.test_mensuel.PC;
            else if (config.type === 'NAS') mensuel += PRICES.test_mensuel.NAS;
            else mensuel += PRICES.test_mensuel.SERVEUR;
        }

        setError(errorMsg);
        setIsDevis(devisDetecte);
        setTotalMensuel(mensuel.toFixed(2));
        setFraisInstallation(install);
    }, [config]);

    return (
        <div className="admin-page">
            <div className="page-content">
                <h1>Simulateur de Devis Sauvegarde</h1>

                <div className="stats-container">
                    <div className="stat-card">
                        <span className="stat-label">Installation (HT)</span>
                        <span className="stat-value" style={{ color: '#90e0ef' }}>
                            {isDevis ? "SUR DEVIS" : `${fraisInstallation}€`}
                        </span>
                    </div>

                    <div className="stat-card">
                        <span className="stat-label">Mensuel (HT)</span>
                        <span className="stat-value">
                            {isDevis ? "SUR DEVIS" : `${totalMensuel}€`}
                        </span>
                    </div>

                    <div className={`stat-card ${error ? 'ko-border' : 'ok-border'}`}>
                        <span className="stat-label">Éligibilité</span>
                        <span className={`stat-value ${error ? 'ko-text' : 'ok-text'}`}>
                            {error ? 'NON' : 'OK'}
                        </span>
                    </div>
                </div>

                <table className="backup-table">
                    <thead>
                        <tr>
                            <th>Paramètre</th>
                            <th>Configuration</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-label="Paramètre">Système (Frais d'install unique)</td>
                            <td data-label="Configuration">
                                <select className="btn" value={config.type} onChange={(e) => setConfig({ ...config, type: e.target.value })}>
                                    <option value="PC">PC</option>
                                    <option value="NAS">NAS</option>
                                    <option value="PHYSIQUE">Serveur Physique</option>
                                    <option value="VIRTUALISE">Serveur Virtualisé</option>
                                </select>
                            </td>
                        </tr>

                        {config.type === 'VIRTUALISE' && (
                            <tr>
                                <td data-label="Paramètre">Nombre de VM</td>
                                <td data-label="Configuration">
                                    <select className="btn" value={config.nbVM} onChange={(e) => setConfig({ ...config, nbVM: e.target.value })}>
                                        {[1, 2, 3, 4, 5].map(n => <option key={n} value={n}>{n}</option>)}
                                        <option value="plus">Plus de 5</option>
                                    </select>
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td data-label="Paramètre">Volume Stockage (Mensuel)</td>
                            <td data-label="Configuration">
                                <select className="btn" value={config.volume} onChange={(e) => setConfig({ ...config, volume: e.target.value })}>
                                    <option value="100">100 Go</option>
                                    <option value="500">500 Go</option>
                                    <option value="1000">1000 Go</option>
                                    <option value="2000">2000 Go</option>
                                    <option value="4000">4000 Go</option>
                                    <option value="auDela">Au delà</option>
                                </select>
                            </td>
                        </tr>

                        <tr>
                            <td data-label="Paramètre">Type de Connexion</td>
                            <td data-label="Configuration">
                                <select className="btn" value={config.connexion} onChange={(e) => setConfig({ ...config, connexion: e.target.value })}>
                                    <option value="ADSL">ADSL</option>
                                    <option value="FTTH">FTTH</option>
                                    <option value="FTTE">FTTE</option>
                                    <option value="FTTO">FTTO</option>
                                </select>
                            </td>
                        </tr>

                        {config.connexion === 'FTTO' && (
                            <tr>
                                <td data-label="Paramètre">Débit Upload (Mbit/s)</td>
                                <td data-label="Configuration">
                                    <input
                                        type="number"
                                        className="btn"
                                        value={config.upload}
                                        onChange={(e) => setConfig({ ...config, upload: parseInt(e.target.value) || 0 })}
                                    />
                                    <a href="https://fast.com" target="_blank" rel="noreferrer" style={{ color: '#90e0ef', display: 'block', marginTop: '5px', fontSize: '0.8rem' }}>
                                        Vérifier sur Fast.com
                                    </a>
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td data-label="Paramètre">Option Test de sauvegarde</td>
                            <td data-label="Configuration">
                                <input
                                    type="checkbox"
                                    checked={config.testSauvegarde}
                                    onChange={(e) => setConfig({ ...config, testSauvegarde: e.target.checked })}
                                />
                                <span style={{ marginLeft: '10px', fontSize: '0.9rem' }}>Inclure le test mensuel</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {error && (
                    <div className="stat-card ko-border" style={{ maxWidth: '900px', margin: '20px auto', background: 'rgba(255, 77, 77, 0.2)' }}>
                        <span className="ko-text">{error}</span>
                    </div>
                )}
            </div>
        </div>
    );
}